import React, { useEffect, useMemo, useState } from "react";
import ErrorDisplay from "../../components/ErrorDisplay/ErrorDisplay";
import { Headings } from "../../components/Headings";
import LoadingMask from "../../components/LoadingMask/LoadingMask";
import PageLayout from "../../components/PageLayout/PageLayout";
import PhoneLayout from "../../components/PhoneLayout/PhoneLayout";
import PlaceSearchResult from "../../components/PlaceSearchResult/PlaceSearchResult";
import { getRecentPlaces } from "../../services/placeService";
import { Place } from "../../types/Place";
import { SitePage } from "../../types/SitePage";
import "./FeedPage.scss";

const FeedPage: React.FC = () => {
  const [recentPlaces, setRecentPlaces] = useState<Place[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setErrorMessage("");

      try {
        const places = await getRecentPlaces(10);
        setRecentPlaces(places);
      } catch (error) {
        setErrorMessage("Failed to load recent places.");
      }

      setLoading(false);
    };

    fetchData();
  }, []);

  const feedContent = useMemo(() => {
    if (loading || errorMessage) {
      return null;
    }

    return (
      <div className="places-section">
        {recentPlaces.length === 0 ? (
          <div className="alert alert-warning">No new places recently.</div>
        ) : (
          <div className="place-list">
            {recentPlaces.map((place) => (
              <PlaceSearchResult key={place.googlePlaceId} place={place} />
            ))}
          </div>
        )}
      </div>
    );
  }, [errorMessage, loading, recentPlaces]);

  if (loading) {
    return <LoadingMask message="Loading activity..." />;
  }

  return (
    <PageLayout title="Feed" page={SitePage.Feed}>
      <PhoneLayout>
        <Headings.PhoneMain>Recently Added Places</Headings.PhoneMain>
        {errorMessage && <ErrorDisplay error={new Error(errorMessage)} />}
        {feedContent}
      </PhoneLayout>
    </PageLayout>
  );
};

export default FeedPage;
